import { Component, Input, OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from 'src/app/_service/message-service';
import { UserService } from 'src/app/_services';
import { VendorService } from 'src/app/_services/vendor.services';
import { Subscription } from 'rxjs';
import { ActualRole } from 'src/app/util/enums/role.enum';
import { UserInfoService } from 'src/app/_services/userInfo.service';


@Component({
  selector: 'telio-gallery-details',
  templateUrl: './gallery-details.component.html',
  styleUrls: ['./gallery-details.component.scss'],
})
export class GalleryDetails implements OnInit {
  subscriptions = new Subscription();
  @Input() vendorId;
  editVendor;
  groupType;
  @Input() maxImageSize = 1048576;
  
  constructor(readonly translate: TranslateService,
    private vendorservice: VendorService,
    private toastr: SnackbarService,
    private userService: UserService,
    readonly userInfoService :UserInfoService) {
  }

  ngOnInit(): void {
    const cpoGroup = [ActualRole.CPO, ActualRole.SUBCPO];
    this.groupType = this.userInfoService.isAdminGroup() ? [cpoGroup[0]] : [cpoGroup[1]];
    this.getvendorinfobyvendorid()
  }

  deleteImage(imgType){
    this.subscriptions.add(this.userService.deleteVendorImage(imgType,this.vendorId).subscribe((resp: any) => {
      if (!!resp) {
        this.toastr.success(this.translate.instant('faq.deleteSuccess'))
        switch(imgType){
          case 'profilePic':
           this.editVendor.profile_pic_url='';
           break;
          case 'companyLogo':
           this.editVendor.company_logo_url='';
           break;
          default:
            break;
        }
      } else {
        this.toastr.error((this.translate.instant('responseFailed')))
      }
    },
      err => {
        this.toastr.error(this.translate.instant('responseFailed'));
      }
    ))
  }

  onFileSelected(e) {
    if (e.target.files.length > 0) {
      this.validateFile(e, "Pic");
    }
  }

  onLogoSelected(e) {
    if (e.target.files.length > 0) {
      this.validateFile(e, "Logo");
    }
  }

  validateFile(e, type) {
    let x = e.target.files[0];
    var fileName = x.name
    var imageSize = x.size
    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
    if (imageSize > this.maxImageSize) {
      this.toastr.error(this.translate.instant('createStation.uploadimgSizeError'))
      e.target.value = null;
      return false
    }
    if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
      const formDataa = new FormData();
      formDataa.append('file', x);
      if (type == "Logo") {
        this.vendorservice.uploadCompanyLogo(this.vendorId, formDataa).subscribe(res => {
          if (x) {
            this.toastr.success(this.translate.instant('faq.addSuccess'));
            this.getvendorinfobyvendorid();
          }
        }, err => {
          this.toastr.error(this.translate.instant('responseFailed'));
        })
      }
      else {
        this.vendorservice.uploadProfilePic(this.vendorId, formDataa).subscribe(res => {
          if (x) {
            this.toastr.success(this.translate.instant('faq.addSuccess'));
            this.getvendorinfobyvendorid();
          }
        }, err => {
          this.toastr.error(this.translate.instant('responseFailed'));
        })
      }
    }
    else {
      this.toastr.error(this.translate.instant('createStation.imgTypeError'));
      e.target.value = null;
      return false
    }
  }
 
  getvendorinfobyvendorid() {
    this.vendorservice.getvendorinfobyvendorid(this.vendorId, this.groupType).subscribe(res => {
      if (res.status_code != "500") {
        this.editVendor = res;
      }
      else if (res.statusCode === "500"){
        this.toastr.error(res.message)
      }
    })
  }
}